import "@babel/polyfill";
import Vue from "vue";
import Vuetify from "vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import dayjs from "./plugins/dayjs";
import "vuetify/dist/vuetify.min.css";

Vue.config.productionTip = false;

Vue.use(dayjs);

Vue.use(Vuetify, {
  theme: {
    primary: "#2bc176",
    secondary: "#5ac8fb",
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
